module.exports = __webpack_public_path__ + "img/succes-pin@2x.ff0150b4.png";